import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { Redirect } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import BackToTop from "./components/BackToTop";
import Header from "./components/header";
import Footer from "./components/footer";
import './App.css';

import Home from './pages/Home';
import Tanztherapie from './pages/Tanztherapie';
import Ueber from './pages/Ueber';
import Kontakt from './pages/Kontakt';
import Links from './pages/Links';
import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';

function App() {
    return <Router>

      <ScrollToTop />

      <Header />

      

      <Switch>
        <Route exact path="/" component={Home} />
        <Route path="/tanztherapie" component={Tanztherapie} />
        <Route path="/ueber" component={Ueber} />
        <Route path="/kontakt" component={Kontakt} />
        <Route path="/links" component={Links} />
        <Route path="/impressum" component={Impressum} />
        <Route path="/datenschutz" component={Datenschutz} />
        <Redirect to="/" />
      </Switch>

      <Footer />

      <BackToTop />

    </Router>;
}

export default App;
